import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import { CMSContextProvider } from "@liro_u/cms-front";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <CMSContextProvider>
    <App />
  </CMSContextProvider>
);
